import { ticketClient } from "@/api/ticketClient";
import { GetTicketRecycleParamReq } from "@/pbjs/external/ticket/ticket_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData, timeFormat, whetherSetParam } from "@/utils";
// lin 获取工单分配支持的所有的参数数据
interface IGetTicketRecycleParamReq {}
export function getTicketRecycleParam() {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetTicketRecycleParamReq();
      request.setCommonin(setCommon());
      ticketClient.getTicketRecycleParam(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
